import { render, staticRenderFns } from "./tab_datos_personales.vue?vue&type=template&id=c89b9d7a&scoped=true"
import script from "./tab_datos_personales.vue?vue&type=script&lang=js"
export * from "./tab_datos_personales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89b9d7a",
  null
  
)

export default component.exports